export default "__VITE_ASSET__CztsEcfQ__"